// extracted by mini-css-extract-plugin
export default {"container":"ErrorMessage_container__rpXQr","inner":"ErrorMessage_inner__2AQfO","video":"ErrorMessage_video__BfKvJ","text":"ErrorMessage_text__3LTKg"};